import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";

import { LOGIN, LOGOUT } from "../constants/auth";
import {
  loginUserSuccess,
  loginUserError,
  logOutUserSuccess
} from "../actions/auth";
import { login, appConstants, logoutApiRoute } from "../../apiRoutes";
import setAuthToken from "../../utils/setAuthToken";

function* loginUser(action) {
  try {
    const response = yield axios
      .post(login, action.payload)
      .then(res => res)
      .catch(err => err.response);
    if (response.status === 200) {
      setAuthToken(response.data.data.accessToken);
      let userData = response.data.data;
      const appConstantsData = yield axios
        .get(appConstants)
        .then(res => res)
        .catch(err => err.response);
      if (appConstantsData.status === 200) {
        let appData = {
          userData: userData,
          appConstant: appConstantsData.data.data
        };
        yield put(loginUserSuccess(appData));
      }
    } else if (response.status === 400 || response.status === 401) {
      yield put(loginUserError(response.data.message));
    } else if (response.status === 500) {
      yield put(
        loginUserError(
          "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        )
      );
    }
  } catch (error) {
    yield put(
      loginUserError(
        "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
      )
    );
    if (process.env.NODE_ENV !== "production") {
      console.log(error);
    }
  }
}

function* logoutUser(action) {
  try {
    if (action.payload && action.payload.id) {
      let formData = new FormData();
      formData.append("doctorId", action.payload.id);
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + action.payload.token;
      const response = yield axios
        .post(logoutApiRoute, formData)
        .then(res => res)
        .catch(err => err.response);
    }

    yield put(logOutUserSuccess());
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.log(error);
    }
  }
}

export default function* authSaga() {
  yield all([takeLatest(LOGIN, loginUser), takeLatest(LOGOUT, logoutUser)]);
}
